import React from "react";
import PropTypes from "prop-types";
import ExitfullscreenGreyOutline from "@druva-apps/orion-icons/lib/ExitfullscreenGreyOutline";
import FullscreenGreyOutline from "@druva-apps/orion-icons/lib/FullscreenGreyOutline";

import Tooltip from "../../tooltip";
import { useTable } from "../context";
import Settings from "./Settings";
import ExportCsv from "./ExportCsv";
import { isFunction } from "../utils";

const Toolbar = ({ width, handleFullScreen, isFullScreen, tableRef }) => {
  const {
    enableFullScreen,
    enableExportToCsv,
    enableConfiguration,
    selectedRows,
    multiSelect,
    selectedRowsCountText,
    paginationEnabled,
    uniqueDataKey,
    toolbarChildren,
    data
  } = useTable();
  let currentRows = selectedRows;
  if (paginationEnabled) {
    const allRowIds = data ? data.map(obj => obj[uniqueDataKey]) : [];
    currentRows = selectedRows.filter(rowId => allRowIds.includes(rowId));
  }

  return (
    <div className="orion-data-grid__toolbar" style={{ width }}>
      {selectedRows.length > 0 && multiSelect && currentRows.length > 0 && (
        <span
          className="oui-text-left oui-col-sm-3 oui-p-0 oui-text-truncate"
          title={selectedRowsCountText}
        >
          <span className="oui-dg-list-count-number oui-d-inline-flex">
            {selectedRows.length}
          </span>
          {selectedRowsCountText}
        </span>
      )}
      <div className="oui-text-center oui-col-sm-5 oui-align-items-center oui-p-0 oui-d-inline-flex oui-justify-content-center">
        {isFunction(toolbarChildren) ? toolbarChildren() : null}
      </div>
      <div className="oui-text-right oui-col-sm-4 oui-p-0 oui-d-inline-flex oui-justify-content-end">
        <span className="">
          {!isFullScreen && enableExportToCsv && (
            <ExportCsv tableRef={tableRef} />
          )}
        </span>
        <span>
          {enableExportToCsv && (enableConfiguration || enableFullScreen) && (
            <span className="data-grid-toolbar-button-separator" />
          )}

          {!isFullScreen && enableConfiguration && (
            <Tooltip text="Customize Table Columns">
              <Settings
                size="sm"
                className="oui-mr-2 data-grid-toolbar-button"
              />
            </Tooltip>
          )}

          {enableFullScreen ? (
            !isFullScreen ? (
              <Tooltip text="Enter Full Screen">
                <button
                  type="button"
                  onClick={handleFullScreen.enter}
                  aria-label="Enter Full Screen"
                  className="orion-data-grid__navigation--empty-button data-grid-toolbar-button"
                >
                  <FullscreenGreyOutline clickable />
                </button>
              </Tooltip>
            ) : (
              <Tooltip text="Exit Full Screen">
                <button
                  type="button"
                  onClick={handleFullScreen.exit}
                  aria-label="Exit Full Screen"
                  className="orion-data-grid__navigation--empty-button data-grid-toolbar-button"
                >
                  <ExitfullscreenGreyOutline clickable />
                </button>
              </Tooltip>
            )
          ) : null}
        </span>
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  width: PropTypes.number,
  handleFullScreen: PropTypes.object,
  isFullScreen: PropTypes.bool,
  tableRef: PropTypes.object
};

export default Toolbar;
